import { render, staticRenderFns } from "./EmptyStateFramed.vue?vue&type=template&id=33542a12&scoped=true&"
import script from "./EmptyStateFramed.vue?vue&type=script&lang=js&"
export * from "./EmptyStateFramed.vue?vue&type=script&lang=js&"
import style0 from "./EmptyStateFramed.vue?vue&type=style&index=0&id=33542a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33542a12",
  null
  
)

export default component.exports